function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 27.5,
  cy: 37.5416,
  r: 5,
  fill: "#1d3f72"
}, React.createElement("animate", {
  attributeName: "cy",
  calcMode: "spline",
  keySplines: "0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5",
  repeatCount: "indefinite",
  values: "62.5;37.5;62.5;62.5",
  keyTimes: "0;0.25;0.5;1",
  dur: "1s",
  begin: "-0.5s"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 42.5,
  cy: 40.7265,
  r: 5,
  fill: "#077a49"
}, React.createElement("animate", {
  attributeName: "cy",
  calcMode: "spline",
  keySplines: "0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5",
  repeatCount: "indefinite",
  values: "62.5;37.5;62.5;62.5",
  keyTimes: "0;0.25;0.5;1",
  dur: "1s",
  begin: "-0.375s"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 57.5,
  cy: 55.4953,
  r: 5,
  fill: "#1d3f72"
}, React.createElement("animate", {
  attributeName: "cy",
  calcMode: "spline",
  keySplines: "0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5",
  repeatCount: "indefinite",
  values: "62.5;37.5;62.5;62.5",
  keyTimes: "0;0.25;0.5;1",
  dur: "1s",
  begin: "-0.25s"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 72.5,
  cy: 62.5,
  r: 5,
  fill: "#077a49"
}, React.createElement("animate", {
  attributeName: "cy",
  calcMode: "spline",
  keySplines: "0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5",
  repeatCount: "indefinite",
  values: "62.5;37.5;62.5;62.5",
  keyTimes: "0;0.25;0.5;1",
  dur: "1s",
  begin: "-0.125s"
}));

var SvgLoader2 = function SvgLoader2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "lds-typing",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLoader2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loader-2.5b6901f8.svg";
export { ForwardRef as ReactComponent };